import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { useNavState } from '@/providers/NavStateProvider';
import { useEffect } from 'react';
import { ScrollTop } from '@/components/element/ScrollTop';
import { PhaseCountAndAmounts } from '@/features/w/[identifier]/dashboard/sales_orders/{components}/PhaseCountAndAmounts';
import { FilterModal } from '@/features/w/[identifier]/dashboard/sales_orders/{components}/FilterModal';
import { MonthlyAnalysis } from '@/features/w/[identifier]/dashboard/sales_orders/{components}/MonthlyAnalysis';
import { AmountByTeam } from '@/features/w/[identifier]/dashboard/sales_orders/{components}/AmountByTeam';
import { CountByProduct } from '@/features/w/[identifier]/dashboard/sales_orders/{components}/CountByProduct';
import { AmountByPhase } from '@/features/w/[identifier]/dashboard/sales_orders/{components}/AmountByPhase';
import { AmountByBusinessPartner } from '@/features/w/[identifier]/dashboard/sales_orders/{components}/AmountByBusinessPartner';
import { AmountByUser } from '@/features/w/[identifier]/dashboard/sales_orders/{components}/AmountByUser';
import { CsvExport } from '@/features/w/[identifier]/dashboard/sales_orders/{components}/CsvExport';
import { SearchConditionTags } from '@/features/w/[identifier]/dashboard/sales_orders/{components}/SearchConditionTags';
import { useIntercomGuide } from '@/hooks/useIntercomGuide';

export const SalesOrdersDashboard = () => {
  const { setTitle, setBreadcrumbs } = useNavState();

  useEffect(() => setTitle('売上ボード'), []);
  useEffect(() => setBreadcrumbs([]), []);

  useIntercomGuide();

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <div className="container-fluid py-4">
        <div className="d-flex align-items-center mb-4">
          <button className="btn btn-icon-only btn-dark mx-2" data-bs-toggle="modal" data-bs-target="#modal-filter">
            <i className="fas fa-filter"></i>
          </button>
          <CsvExport />
        </div>

        <SearchConditionTags />

        <FilterModal />

        <PhaseCountAndAmounts />

        <MonthlyAnalysis />

        <div className={'row'}>
          <AmountByTeam />
          <CountByProduct />
        </div>

        <div className={'row'}>
          <AmountByPhase />
          <AmountByBusinessPartner />
          <AmountByUser />
        </div>
      </div>
    </WorkspaceLayout>
  );
};
